module.exports = __webpack_public_path__ + "img/card3.24d2e35c.jpg";